import Base from '../config/Base';
import ep from '../../endPoints.constant';
class Property extends Base {
    validateToken(token) {
        const url = ep.user.validateToken();
        if (token)
            return this.apiClient.get(url, { token });
        return this.apiClient.get(url);
    }
    recoverPassword(email) {
        const url = ep.user.recoverPassword(email);
        return this.apiClient.put(url, {}, {});
    }
    createUser(data) {
        const url = ep.user.createUser();
        return this.apiClient.post(url, {}, data);
    }
    updateUser(id, data) {
        const url = ep.user.userById(id);
        return this.apiClient.put(url, {}, data);
    }
    getUser(id) {
        const url = ep.user.userById(id);
        return this.apiClient.get(url, {});
    }
    getUserByToken(token) {
        const url = ep.user.userByToken();
        return this.apiClient.get(url, {
            token,
        });
    }
    getRedeemInvite(inviteId, hashId) {
        const url = ep.user.redeemInvite();
        return this.apiClient.get(`${url}?inviteId=${inviteId}&hash=${hashId}`, {});
    }
    saveRedeemInvite(data) {
        const url = ep.user.redeemInvite();
        return this.apiClient.post(url, {}, data);
    }
}
export default Property;
